import { cva } from 'class-variance-authority';
import React from 'react';
import { cn } from '../../lib/cn';

const alertVariants = cva(
  'relative w-full rounded-lg px-3 py-2.5 text-xs font-medium [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-6 dark:border-border dark:[&>svg]:text-foreground',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-secondary-foreground',
        success: 'bg-primary/10 text-primary [&>svg]:text-primary',
        info: 'bg-background border border-border shadow-subtle-sm text-blue-700 [&>svg]:text-blue-700',
        warning: 'bg-yellow-700/10 text-yellow-700 [&>svg]:text-yellow-700',
        destructive: 'bg-background border border-border text-rose-600/70 [&>svg]:text-rose-600/70',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef(({ className, children, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn('mb-1 text-xs font-medium leading-none tracking-tight md:text-sm', className)}
    {...props}
  >
    {children}
  </h5>
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('inline-flex gap-2 text-xs [&_p]:leading-relaxed', className)}
    {...props}
  />
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
